import { ReactElement } from "react";

const NonePage = (): ReactElement => {
    return (
        <></>
    );
}

export default NonePage;